import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import Vant from 'vant'
import 'vant/lib/index.css';

import pcormove from './assets/function/pcormove'; // 判断pc还是移动
import message from './assets/function/message'; //消息提示框

import VueI18n from 'vue-i18n'; //中英文切换
Vue.use(VueI18n);

import enLocale from 'element-ui/lib/locale/lang/en'
import chLocale from 'element-ui/lib/locale/lang/zh-CN'
import jpLocale from 'element-ui/lib/locale/lang/ja'

import enUS from 'vant/es/locale/lang/en-US';
import zhCN from 'vant/es/locale/lang/zh-CN';
import JaJP from 'vant/es/locale/lang/ja-JP';

import ElementLocale from 'element-ui/lib/locale'
import ch_pkg from './language/ch.js'
import en_pkg from './language/en.js'
import jp_pkg from './language/jp.js'

import authjson from './assets/function/authjson'; // 权限方法


import { Locale } from 'vant';
let stg_language = localStorage.getItem('language');


// 使用时间转换插件 moment.js
import moment from 'moment'

Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(Vuex);
Vue.config.productionTip = false

Vue.prototype.bus = new Vue();
Vue.prototype.pcormove = pcormove;
Vue.prototype.message = message;
Vue.prototype.v_lan = stg_language;
Vue.prototype.authjson = authjson;
// 全局  overall
function custom_moment(v) {
  if(v==0){
    return 0;
  }
  if(stg_language=='en'){
    return moment(v).format('DD/MM/YYYY, hh:mma');
  }else{
    return moment(v).format('YYYY/MM/DD HH:mm');
  }
}
function custom_moment2(v) {
  if(v==0){
    return 0;
  }
  if(stg_language=='en'){
    return moment(v).format('DD/MM/YYYY');
  }else{
    return moment(v).format('YYYY/MM/DD');
  }
}
// 时间转换
Vue.prototype.overall_time = custom_moment;
Vue.prototype.overall_time2 = custom_moment2;

// 数字 每三位数加一个逗号 1,000 
function capitalize(val) {
  if (val=='-') {
    return "-";
  }
  if (val==="0"||val===0) {
    return "0";
  }
  if (!val) {
    return "";
  }
  let num=val+"";
  if (num.indexOf('.') != -1) {
      let num1 = num.split('.')[0];//整数
      let num2 = num.split('.')[1];//小数
      let num3 = num1.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
      if (num2.length==1) {
        return num3+"."+num2+"0";
      }else{
        return num3+"."+num2;
      }
      
  }else{
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')+".00";
  }
}
Vue.prototype.set_num3 = capitalize;

// 数字 每三位数加一个逗号 1,000 
function capitalize2(val) {
  if (val=='-') {
    return "-";
  }
  if (val==="0"||val===0) {
    return "0";
  }
  if (!val) {
    return "";
  }
  let num=val+"";
  if (num.indexOf('.') != -1) {
    let num1 = num.split('.')[0];//整数
    let num2 = num.split('.')[1];//小数
    let num3 = num1.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    return num3+"."+num2;
  }else{
    return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
  }
}
Vue.prototype.set_num3_2 = capitalize2;

// 随机数 16位
function createCode() {
  var code = "";
  var codeLength = 16;
  var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
  for (var i = 0; i <= codeLength; i++) {
      var index = Math.floor(Math.random() * 9);
      code += random[index];
  }
  return code;
}
Vue.prototype.random_16 = createCode();


//vant国家化判断
switch (stg_language) {
  case 'ch':
      Locale.use('zh-CN', zhCN);
      break;
  case 'en':
      Locale.use('en-US', enUS);
      break;
  case 'jp':
      Locale.use('ja-JP', JaJP);
      break;
  default:
      Locale.use('en-US', enUS);
      localStorage.setItem('language', 'en');
}
const i18n = new VueI18n({
  locale: stg_language,
  messages: {
    'ch': {
      ...ch_pkg,
      ...chLocale
    },
    'en': {
      ...en_pkg,
      ...enLocale
    },
    'jp': {
      ...jp_pkg,
      ...jpLocale
    },
  }
})

ElementLocale.i18n((key, value) => i18n.t(key, value))

// Canvas 手写签字 电子签名
import vueEsign from 'vue-esign'
Vue.use(vueEsign);

store.dispatch('login/RouterAuth') //路由守卫

// 版本号的判断逻辑，版本号不一致就重新加载
const VUE_APP_VERSION = require('../package.json').version;
const vers = window.localStorage.getItem("FEB_Version");
if(VUE_APP_VERSION != vers){
  localStorage.clear();
  sessionStorage.clear();
  window.localStorage.setItem("FEB_Version", VUE_APP_VERSION);
  location.reload();
}

// 过滤card number 后四位展示其余变成**
Vue.filter('filterCardNumber', (value) => {
  if (!value) return '-';
  value = value.toString();
  let length = value.length - 4;
  value = value.slice(length);
  for (let i = 0; i < length; i++) {
    if ((i) % 4 == 0 || i == 0) {
      value = " " + value;
    }
    value = "*" + value;
  }

  return value;
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
